import React, { Component } from 'react';

import { Col } from 'antd';

import utils from '../../../../../helpers/utils';

import './SummaryBadge.css';

export default class SummaryBadge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opacity: '0.5',
      selected: false
    };
  }

  setOpacity = opacity => () => {
    if (!this.state.selected) {
      this.setState({ opacity });
    }
  };

  onClick = e => {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  static getDerivedStateFromProps(props, state) {
    if (props.selected !== state.selected) {
      return { opacity: props.selected ? '1' : '0.5', selected: props.selected };
    }
    return state;
  }

  render() {
    const rgb = utils.hexToRgb(this.props.color);
    return (
      <Col style={{ ...this.props.style }} className={'SummaryBadge' + (this.props.selected === true ? ' selected' : '')}>
        <div
          style={{
            borderColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${this.state.opacity})`,
            backgroundColor: this.props.selected ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${this.state.opacity})` : 'white'
          }}
          onMouseEnter={this.setOpacity('1')}
          onMouseLeave={this.setOpacity('0.5')}
          onClick={this.onClick}
        >
          {/* !!this.props.icon && (
            <span style={{ display: 'flex', paddingBottom: '5px', color: this.props.selected ? 'white' : `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${this.state.opacity})` }}>
              {this.props.icon}
            </span>
          ) */}
          <span
            style={{
              textAlign: 'center',
              padding: '0 5px 5px',
              color: this.props.selected ? 'white' : `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${this.state.opacity})`,
              fontSize: '1rem'
            }}
          >
            {this.props.label}
          </span>
          <span style={{ fontSize: '1.4rem', lineHeight: '1rem', color: this.props.selected ? 'white' : `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${this.state.opacity})` }}>
            {this.props.count}
          </span>
        </div>
      </Col>
    );
  }
}
